module.exports = __webpack_public_path__ + "img/uenoyama-taiyo.f9134426.jpg";